import { InMemoryPasskeyStorage } from '@train-protocol/auth';
const STORAGE_KEY = 'passkey-credentials';
/** Persistent IndexedDB-backed storage for passkey credentials (id + user-chosen label). */
export class IndexedDBPasskeyStorage {
    constructor(storage) {
        this.storage = storage;
        this.memory = new InMemoryPasskeyStorage();
    }
    /** Load credentials from IndexedDB into memory. Call after SecureStorage.init(). */
    async init() {
        try {
            const stored = await this.storage.getJSON(STORAGE_KEY);
            if (!stored || !Array.isArray(stored.credentials))
                return;
            for (const entry of stored.credentials) {
                if (entry && typeof entry.id === 'string') {
                    this.memory.storeCredentialId(entry.id, entry.label);
                }
            }
            if (stored.activeId && stored.credentials.some(c => c?.id === stored.activeId)) {
                // storeCredentialId promotes last-added to active, so re-apply the persisted activeId
                this.memory.storeCredentialId(stored.activeId);
            }
        }
        catch { /* ignore corrupt data */ }
    }
    getActiveCredentialId() {
        return this.memory.getActiveCredentialId();
    }
    getAllCredentials() {
        return this.memory.getAllCredentials();
    }
    getAllCredentialIds() {
        return this.memory.getAllCredentialIds();
    }
    async storeCredentialId(credId, label) {
        this.memory.storeCredentialId(credId, label);
        await this.persist();
    }
    async removeCredentialId(credId) {
        this.memory.removeCredentialId(credId);
        await this.persist();
    }
    async clearAllCredentials() {
        this.memory.clearAllCredentials();
        await this.persist();
    }
    async persist() {
        try {
            await this.storage.setJSON(STORAGE_KEY, {
                credentials: this.memory.getAllCredentials(),
                activeId: this.memory.getActiveCredentialId(),
            });
        }
        catch { /* storage error, in-memory still valid */ }
    }
}
